export enum AppMimeType {
    WEBM = 'video/webm',
    MP4 = 'video/mp4',
}